export default __webpack_public_path__ + "static/media/safety-governance.png";